// Add your custom JS here.
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

import TomSelect from 'tom-select/dist/js/tom-select.complete';
import { Tab } from 'bootstrap';

function resizeWindow() {
	let htmlHeight = window.innerHeight;
	let htmlWidth = window.innerWidth;

	if(htmlWidth >= 992) {
		let paddings = 32;
		let resultContainerHeight = htmlHeight - paddings;
		document.querySelector("#col-carte").style.height = resultContainerHeight+"px";
		document.querySelector("#backyou-map").style.height = resultContainerHeight+"px";
	}
}

if (document.getElementById('archive-hotels-container')) {
	new TomSelect('#search-theme', {
		plugins: {
			remove_button: {
				title: 'Effacer',
			}
		}
	});

	addEventListener("resize", (event) => {
		resizeWindow();
	});
	resizeWindow();

	

	const btns = document.querySelectorAll('#tab-liste-carte .btn-check');
	btns.forEach(btnEl => {

		let target = btnEl.dataset.target;
		btnEl.addEventListener('click', event => {
			document.querySelectorAll('.col-archive').forEach(colEl => {
				colEl.classList.add('d-none');
			});
			if(document.getElementById(target)) {
				document.getElementById(target).classList.remove('d-none');
			}
		})
	})

}

if (document.getElementById('wrapper-footer')) {

	const options = {
		dataSource: []
	};

	const images = document.querySelectorAll('.image-gallery');
	images.forEach((span) => {
		options.dataSource.push(
			{
				src: span.dataset.imgUrl,
				width: span.dataset.width,
				height: span.dataset.height
			}
		)
	});

	document.querySelectorAll('.hotel-image').forEach((img) => {
		img.onclick = () => {
			options.index = 0; // defines start slide index
			const pswp = new PhotoSwipe(options);
			pswp.init(); // initializing PhotoSwipe core adds it to DOM
		}
	});
}